export class SurveysService {
  constructor(axios, apiUrl, apiCmsUrl,) {
    this.$axios = axios;
    this.apiUrl = apiUrl;
    this.apiCmsUrl = apiCmsUrl;
  }

  getSurveyTypeByGUID(guid) {
    let surveyGUIDs = new Map();
    surveyGUIDs.set("284BB93C-02F1-43A5-89FD-021E0A20DCA4", "CANCEL");
    surveyGUIDs.set("416FA706-4829-4D55-854C-D28D4651B2D1", "UNCONVERTED");
    surveyGUIDs.set("00FA4CB5-A28D-4606-B5E7-6570BD8E11AF", "PREFERRED");
    surveyGUIDs.set("1324932C-B53K-FJ31-BJ36-9GD89DF80C0S", "EXPECTATION");
    surveyGUIDs.set("D1096CAC-A3E2-4E15-92AC-8F0589893653", "SATISFACTION");
    surveyGUIDs.set("FC8A83EC-F6AD-4D93-A9CF-BDAE5C0BFBC1", "IRRIGATION");
    return surveyGUIDs.get(guid);
  }

  async getSurveys(customerId, companyId) {
    const response = await this.$axios.get(
      `${this.apiUrl}surveys/customer/${customerId}/company/${companyId}`
    );

    return response?.data;
  }

  async getCompletedSurvey(surveyId) {
    const response = await this.$axios.get(
      `${this.apiUrl}Surveys/Completed/${surveyId}`
    );
    
    return response?.data;
  }

  async updateSurvey(data, sessionId) {
    return await this.$axios.post(this.apiUrl + `Surveys/Survey`, data, {
      headers: {
        'X-SessionId': sessionId,
      }
    }).then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      return {error: error, response: error.response.data };
    });
  }

  async getSurveyQuestionAnswer(guid) {
      return await this.$axios.get(
        this.apiUrl + 'Surveys/Survey/' + guid
      ).then(function(response) {
          return response.data;
      })
      .catch(function(error) {
          return {error: error, response: error.response.data };
      });
  }
  async getBranchInfo(franchiseID) {
    return await this.$axios.get(
      this.apiUrl + 'Cache/UCMS/Companies/Company/Branch/' + franchiseID
    ).then(function(response) {
        return response.data;
    })
    .catch(function(error) {
        return {error: error, response: error.response.data };
    });
  }

  //Calling October API
  async getSurveyInfo() {
    return await this.$axios.get(
      this.apiCmsUrl + 'pages/survey'
    ).then(function(response) {
        return response.data;
    })
    .catch(function(error) {
        return {error: error, response: error.response.data };
    });
  }
}
